import HttpAPICall from "./HttpAPICall";
import { ORG_API_BASE_URL_2 } from "./TapApiUrls";

class CurrencyService {
    constructor(accessToken) {
        this.accessToken = accessToken;
        this.apiUrl = ORG_API_BASE_URL_2 + "/currency/convert"; // Replace with your API URL
    }

    async convert(amount, fromCurrency, toCurrency) {
        if (fromCurrency === toCurrency) return amount;
        
        return new Promise((resolve, reject) => {
            HttpAPICall.withAthorization(
                "GET",
                this.apiUrl,
                this.accessToken,
                { from: fromCurrency, to: toCurrency },
                null,
                (response) => {
                    const convertedAmount = amount * response.data.rate;
                    resolve(parseFloat(convertedAmount.toFixed(2)));
                }
            ).catch(reject);
        });
    }
}

export default CurrencyService;